import React, { useEffect } from "react";
import { Settings as SettingsIcon } from "lucide-react";
import { PrivacySettings } from "@/components/settings/PrivacySettings";

export default function Settings() {
  useEffect(() => { document.title = "Settings — Living Wisdom Explorer"; }, []);
  return (
    <div className="max-w-3xl mx-auto px-6 py-10 relative z-10" data-testid="settings-page">
      <div className="flex items-center gap-2 text-primary mb-1">
        <SettingsIcon className="w-4 h-4" />
        <span className="text-xs font-semibold uppercase tracking-wide">Your account</span>
      </div>
      <h1 className="font-serif text-4xl tracking-tight-serif text-foreground">Settings</h1>
      <p className="text-muted-foreground mt-2 max-w-xl">
        Manage your preferences. Looking for AI providers? They now live under{" "}
        <span className="text-foreground font-medium">AI Keys</span> in your account menu.
      </p>

      <section className="mt-8">
        <h2 className="font-serif text-2xl text-foreground mb-4">Privacy</h2>
        <PrivacySettings />
      </section>
    </div>
  );
}
